'use client';

import { useState, useRef, useCallback, useEffect } from 'react';

function easeOutExpo(x) {
    return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
}
function useCountNumber(_a) {
    var _b = _a.from, from = _b === void 0 ? 0 : _b, to = _a.to, _c = _a.duration, duration = _c === void 0 ? 5000 : _c, _d = _a.enable, enable = _d === void 0 ? true : _d;
    // state
    var _e = useState(from), count = _e[0], setCount = _e[1];
    // refs
    var hasCountedUp = useRef(false);
    // logic
    var countNumber = useCallback(function () {
        var startTime = performance.now();
        var updateNumber = function (currentTime) {
            var ellapsedTime = currentTime - startTime;
            if (ellapsedTime > duration) {
                setCount(to);
            }
            else {
                var rate = easeOutExpo(ellapsedTime / duration);
                var ellapsedNumber = to - from;
                var currentNumber = from + Math.round(ellapsedNumber * rate);
                setCount(currentNumber);
                requestAnimationFrame(updateNumber);
            }
        };
        requestAnimationFrame(updateNumber);
    }, [duration, to, from]);
    // effects
    useEffect(function () {
        if (enable && !hasCountedUp.current) {
            countNumber();
            hasCountedUp.current = true;
        }
    }, [countNumber, enable]);
    return count;
}

export { useCountNumber as default };
//# sourceMappingURL=useCountNumber.js.map
